export default {
  metaDescription: 'PT Tokki Engineering and Fabrication(TEF)による記事全文をご覧いただけます。会社ニュース、プロジェクトの節目、業界インサイトを掲載しています。',
  pageTitle: 'ニュース・ブログ詳細',
  backToList: 'ニュース・ブログ一覧へ戻る',
  sidebar: {
    title: 'ニュース・その他のブログ',
  },
};
